import { twMerge } from 'tailwind-merge';
import showsIconSvg from '@/icons/shows.svg?raw';

interface ShowsIconProps {
  className?: string;
}

/**
 * Renders the shows glyph from `src/icons/shows.svg`.
 */
export const ShowsIcon = ({ className }: ShowsIconProps) => (
  <span
    className={twMerge(
      'inline-flex shrink-0 text-current [&_svg]:block [&_svg]:shrink-0',
      className
    )}
    aria-hidden
    dangerouslySetInnerHTML={{ __html: showsIconSvg }}
  />
);
